// Per-page-load cache for /api/diUsers. The roster is treated as static
// for the lifetime of the SPA — first caller triggers the fetch, every
// subsequent caller resolves to the same promise.

let inflight = null;

export function loadDiUsers() {
  if (inflight) return inflight;
  inflight = fetch('/api/diUsers', { credentials: 'include' })
    .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
    .then(data => data.users || [])
    .catch(err => { inflight = null; throw err; });
  return inflight;
}
